// app.js
!function(root, factory){

    factory(root);

}(this, function(root){

    function App(){

        this.extend = function(opts){
    		_.merge(this, opts);
        };

    };

    return root.app = root.app || new App();

});
